import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { frenchbooktranslationfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            French Book Translation Services
        </title>
        <meta
          name="description"
          content="Professional French translation services for books, maintaining style, tone, and readability."
        />
        <meta name="keywords" content="French Book Translation" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg frenchbooktranslationbg"
          title=""
          subtitle=" French Translation "
          title2="for Every Genre and Audience"
          para="Our French translation service adapts your book with precision and cultural sensitivity for every genre. We ensure your story’s voice, tone, and emotion resonate authentically, engaging French-speaking readers across the globe."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={`Expert Translation That Maintains  `}
          subtitle="  Meaning and Style "
          title2=""
          description={`Translating a book into French requires more than literal word-for-word conversion, it demands preserving the essence, style, and meaning of your original work. Our expert French translation service ensures that every sentence reflects your unique voice, narrative tone, and emotional impact, allowing readers to experience your story just as you intended. We carefully adapt idioms, cultural references, and phrasing to resonate naturally with French-speaking audiences while maintaining authenticity. Whether it’s fiction, non-fiction, memoir, or children’s literature, each translation is meticulously reviewed for clarity, flow, and consistency. By balancing accuracy with creativity, we deliver a French edition that engages, entertains, and connects deeply with readers. Expand your global reach without compromising the heart of your story. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={frenchbooktranslationfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
